<template>
  <div class="premium-upgrade-container">
    <div class="container mt-5">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6">
          <div class="card shadow">
            <div class="card-header bg-primary text-white text-center">
              <h3 class="mb-0">
                <i class="mdi mdi-crown me-2"></i>
                Upgrade to Premium
              </h3>
            </div>
            <div class="card-body">
              <!-- Premium Features -->
              <div class="premium-features mb-4">
                <h5 class="mb-3">Premium Features Include:</h5>
                <ul class="list-unstyled">
                  <li class="mb-2">
                    <i class="mdi mdi-check-circle text-success me-2"></i>
                    Advanced hunt planning tools
                  </li>
                  <li class="mb-2">
                    <i class="mdi mdi-check-circle text-success me-2"></i>
                    Priority customer support
                  </li>
                  <li class="mb-2">
                    <i class="mdi mdi-check-circle text-success me-2"></i>
                    Exclusive hunting insights and data
                  </li>
                  <li class="mb-2">
                    <i class="mdi mdi-check-circle text-success me-2"></i>
                    Advanced mapping features
                  </li>
                  <li class="mb-2">
                    <i class="mdi mdi-check-circle text-success me-2"></i>
                    Export capabilities for hunt applications
                  </li>
                </ul>
              </div>

              <!-- Pricing -->
              <div class="pricing-section text-center mb-4">
                <div class="price-display">
                  <span class="price-amount">$20</span>
                  <span class="price-period">/year</span>
                </div>
                <p class="text-muted">Cancel anytime</p>
              </div>

              <!-- Secure Payment Info -->
              <div class="payment-info-section mb-4">
                <div class="alert alert-info">
                  <i class="mdi mdi-shield-check me-2"></i>
                  <strong>Secure Payment:</strong> You'll be redirected to Stripe's secure checkout page to complete your payment safely.
                </div>
              </div>

              <!-- Error Messages -->
              <div v-if="errorMessage" class="alert alert-danger">
                {{ errorMessage }}
              </div>

              <!-- Success Message -->
              <div v-if="successMessage" class="alert alert-success">
                {{ successMessage }}
              </div>

              <!-- Action Buttons -->
              <div class="d-grid gap-2">
                <button 
                  class="btn btn-primary btn-lg"
                  @click="processPremiumUpgrade"
                  :disabled="isProcessing"
                >
                  <span v-if="isProcessing">
                    <div class="spinner-border spinner-border-sm me-2" role="status"></div>
                    Processing...
                  </span>
                  <span v-else>
                    Upgrade to Premium - Only $20/year!
                  </span>
                </button>
                
                <button 
                  class="btn btn-outline-secondary"
                  @click="$emit('close')"
                  :disabled="isProcessing"
                >
                  Maybe Later
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStripe } from '../utils/stripe';

export default {
  name: 'PremiumUpgrade',
  data() {
    return {
      isProcessing: false,
      errorMessage: null,
      successMessage: null,
    };
  },
  methods: {
    async processPremiumUpgrade() {
      this.isProcessing = true;
      this.errorMessage = null;
      this.successMessage = null;

      try {
        // Create Stripe Checkout Session
        const response = await fetch(this.$API_BASE_URL + "/api/payment/create-checkout-session-stripe", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            priceId: 'price_premium_annual', // Your Stripe price ID
            successUrl: window.location.origin + '/payment/success',
            cancelUrl: window.location.origin + '/premium-cancel',
          }),
        });

        if (response.ok) {
          const { id: sessionId, url: url } = await response.json();
          
          // Redirect to Stripe Checkout
          const stripe = await getStripe();
          const { error } = await stripe.redirectToCheckout({
            sessionId: sessionId,
          });

          if (error) {
            this.errorMessage = `Checkout Error: ${error.message}`;
          }
        } else {
          const errorData = await response.json();
          this.errorMessage = `Failed to create checkout session: ${errorData.message || 'Unknown error occurred'}`;
        }

      } catch (error) {
        this.errorMessage = `Error: ${error.message}`;
      } finally {
        this.isProcessing = false;
      }
    },
  },
};
</script>

<style scoped>
.premium-upgrade-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  overflow-y: auto;
}

.card {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.premium-features ul li {
  padding: 0.25rem 0;
}

.price-display {
  font-size: 2.5rem;
  font-weight: bold;
  color: #0570de;
  margin-bottom: 0.5rem;
}

.price-amount {
  font-size: 3rem;
}

.price-period {
  font-size: 1.5rem;
  color: #6c757d;
}

.payment-method-option {
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.payment-method-option:hover {
  border-color: #0570de;
  background-color: #f8f9fa;
}

.payment-method-option.selected {
  border-color: #0570de;
  background-color: #e7f3ff;
}

.saved-methods {
  max-height: 200px;
  overflow-y: auto;
}

@media (max-width: 768px) {
  .container {
    padding: 1rem;
  }
  
  .price-display {
    font-size: 2rem;
  }
  
  .price-amount {
    font-size: 2.5rem;
  }
}
</style>
